import { render, staticRenderFns } from "./TargetingDetails.vue?vue&type=template&id=01743a2a&scoped=true&"
import script from "./TargetingDetails.vue?vue&type=script&lang=js&"
export * from "./TargetingDetails.vue?vue&type=script&lang=js&"
import style0 from "./TargetingDetails.vue?vue&type=style&index=0&id=01743a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01743a2a",
  null
  
)

export default component.exports